import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OktaService } from './okta.service';
import { environment } from '../../../environments/environment';
import { HcToastOptions, HcToasterService } from '@healthcatalyst/cashmere';

export interface ChangeElement {
    'changeID'?: number,
    'item': number,
    'name': string,
    'category': string,
    'field': string,
    'previous': string,
    'update': string,
    'user': string,
    'date': string
}

export interface ChangeInput {
    'categories'?: string,
    'item'?: number,
    'startDate'?: string,
    'endDate'?: string
}

@Injectable()
export class ChangeService {
    loadFailed = false;

    constructor( private http: HttpClient, private oktaService: OktaService, private toasterService: HcToasterService ){};

    load( target: ChangeInput ): Observable<any> {
        this.loadFailed = false;

        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = {headers: headers};

        return this.http.post<any>( environment.azure.url + '/changes', target, options);
    }

    generate(target: ChangeInput): Observable<any>{
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = {headers: headers};

        return this.http.post<any>( environment.azure.url + ' /changes.generate', options);
    }

    add( targets: ChangeElement[] ) {
        // Write target to database
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('Authorization', `Bearer ${this.oktaService.accessToken}`);
        const options = {headers: headers};

        let postSub = this.http.post<any>( environment.azure.url + '/admin.changes.add', targets, options )
        .subscribe({
            error: msg => {
                const options: HcToastOptions = {
                    header: 'Change History Failed',
                    body: "Unable to save change log.",
                    type: 'alert',
                    position: 'bottom-right'
                };
                this.toasterService.addToast(options);
                console.log( msg );
                postSub.unsubscribe();
            }
        });
    }
}
